import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import { CarrierAppointmentsCSVInput } from "./interfaces";

const columns: GridColDef[] = [
  { field: 'producerFirstName', headerName: 'Producer First Name', width: 150 },
  { field: 'producerLastName', headerName: 'Producer Last Name', width: 150 },
  { field: 'NPN', headerName: 'NPN', width: 120 },
  { field: 'appointmentState', headerName: 'Appointment State', width: 130 },
  { field: 'producerStatus', headerName: 'Producer Status', width: 130 },
  { field: 'carrierLegalName', headerName: 'Carrier Legal Name', width: 180 },
  { field: 'carrierBrandName', headerName: 'Carrier Brand Name', width: 180 },
  { field: 'HIOS', headerName: 'HIOS', width: 120 },
  { field: 'NAICCode', headerName: 'NAIC Code', width: 120 },
  { field: 'lineOfAuthority', headerName: 'Line of Authority', width: 150 },
  { field: 'lineOfAuthorityStatus', headerName: 'LOA Status', width: 120 },
  { field: 'appointmentStatus', headerName: 'Appointment Status', width: 150 },
  { field: 'appointmentEffectiveDate', headerName: 'Effective Date', width: 130 },
  { field: 'appointmentExpirationDate', headerName: 'Expiration Date', width: 130 },
  { field: 'uplineAgency', headerName: 'Upline Agency', width: 150 },
  { field: 'commissionStructure', headerName: 'Commission Structure', width: 160 },
  { field: 'pmpmRate', headerName: 'PMPM Rate', width: 120, type: 'number' },
  { field: 'percent', headerName: 'Percent', width: 100, type: 'number' },
];

export function CarrierAppointmentsTable({ rows }: { rows: CarrierAppointmentsCSVInput[] }) {
  return (
    <Box sx={{ height: 600, width: '100%' }}>
        <DataGrid columns={columns} rows={rows} />
    </Box>
  );
}
